<template>

    <section class="banner-section align-items-center">
        <!-- <div class="custom-container">
            <div class="row">
                <div class="col-md-10 col-lg-8">
                    <div class="banner-content">
                        <div class="navbar-brand logo banner-label" style="width:90% !important">
                            <img src="@/assets/img/banner-text.png" class="img-fluid" alt="Logo">
                        </div>
                        <div class="banner-btn">
                            <router-link to="/login" class="btn banner-primary">Ayo Bergabung Sekarang</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="breadcrumb-bar">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-md-12 col-12">
                        <nav aria-label="breadcrumb" class="page-breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
                                <li class="breadcrumb-item active" aria-current="page">Kategori {{namakat}}</li>
                            </ol>
                        </nav>
                        <!-- <h2 class="breadcrumb-title">Kelas CPNS</h2> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="custom-container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-12 col-sm-12 col-lg">
                        <VueSlickCarousel  v-bind="settings" v-if="lstkatbanner.length">
                            <div class="banner-content" v-for="(ref) in lstkatbanner" :key="ref.id">
                                <img  :src="ref.link_banner" />
                                <!-- <img  :src="loadImg(ref.link_banner)" /> -->
                            </div>
                            <!-- <div class="banner-content"><img src="@/assets/img/banner-2.jpg" /></div>
                            <div class="banner-content"><img src="@/assets/img/banner-2.jpg" /></div> -->
                         
                        </VueSlickCarousel>
                </div>
            </div>
        </div>
        
        <div class="custom-container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-12 col-sm-12 col-lg">
                    <div class="">
                        <VueSlickCarousel v-bind="settingCategory" v-if="lstkat.length">
                            
                             
                            <div class="widget-profile pro-widget-content" v-for="(ref) in lstkat" :key="ref.id">
                               
                                <div v-if="ref.status!='1'" :class="{'profile-info-widget' : true, 'mt-12' : ref.status!='1'}">
                                    <div class="bg-warning px-2 pt-1 pb-0.5 comingsoon"><p>COMING SOON</p></div>
                                        
                                    <div  :class="{'booking-doc-img booking-doc-img2' : true, 'icon-disable' : ref.status!='1'}">
                                        <img :src="ref.icon" alt="User Image">
                                    </div>
                                    <div :class="{'profile-det-info' : true, 'text-disable' : ref.status!='1'}">
                                        <p>{{ref.nama_kat}}</p>
                                    </div>
                                </div>

                                <div v-else :class="{'profile-info-widget' : true, 'mt-12' : ref.status!='1'}">
                                    
                                    <a  @click.prevent="getKategori(ref.id)">
                                        <div  :class="{'booking-doc-img booking-doc-img2' : true, 'icon-disable' : ref.status!='1'}">
                                            <img :src="ref.icon" alt="User Image">
                                        </div>
                                        <div :class="{'profile-det-info' : true, 'text-disable' : ref.status!='1'}">
                                            <p>{{ref.nama_kat}}</p>
                                        </div>
                                    </a>
                                </div>
                            </div>

                        </VueSlickCarousel>
                    </div>
                </div>

                
                <div class="col-md-12 col-lg-12 text-center" :class="{'judul-paket': idcat!='1'}">
                    <!-- <div class="slider-section-header"> -->
                        <h2 v-if="idcat != '1'">Paket {{namakat}}</h2>
                        <div  v-if="idcat == '1'">
                            <h3>Jutaan orang merasa kesulitan menemukan metode belajar yang efektif</h3>
                        </div>

                    <!-- </div> -->
                </div>

            </div>
        </div>


        <!-- <div class="custom-container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-12 col-sm-12 col-lg">
                    <div class="card">
                        <VueSlickCarousel v-bind="settingCategory">
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/external-microdots-premium-microdot-graphic/64/undefined/external-administration-human-civilization-vol1-microdots-premium-microdot-graphic.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Kelas CPNS</p>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/external-microdots-premium-microdot-graphic/64/undefined/external-citizen-human-civilization-vol1-microdots-premium-microdot-graphic.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Kelas BUMN</p>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/external-microdots-premium-microdot-graphic/64/undefined/external-brainstorm-human-civilization-vol1-microdots-premium-microdot-graphic.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Pelatihan Soft Skill & Hard Skill</p>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/external-vitaliy-gorbachev-flat-vitaly-gorbachev/58/undefined/external-graduation-hat-event-vitaliy-gorbachev-flat-vitaly-gorbachev.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Sukses PTN & PTK (UTBK & Sekolah Kedinasan)</p>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/color/96/undefined/school-building.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Bimbel SMA</p>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/external-flaticons-flat-flat-icons/64/undefined/external-search-seo-flaticons-flat-flat-icons.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Program Lainnya</p>
                                    </div>
                                </div>
                            </div>
                        </VueSlickCarousel>
                    </div>
                </div>
            </div>
        </div> -->

        <section class="top-courses-section" :class="{'bg-white':idcat == '1'}">

            <div class="custom-container">

                <div class="row align-items-center">
                    <template v-if="idcat == '1'" >
                    <div class="">
                        <div class="col-12 text-center">
                            <LazyYoutube
                            ref="youtubeLazyVideo"
                            src="https://youtu.be/J1HIWKCvzOo"
                            max-width="400px"
                            aspect-ratio="16:9"
                            thumbnail-quality="standard"
                            />
                        </div>

                        <div class="col-12 text-center px-2 pt-1 pb-0.5">
                            <p>Sebagian dari mereka merasa sulit memahami materi secara utuh meskipun mereka sudah berhasil menghafalkannya. Bahkan ada banyak dari mereka yang tetap belum memahami sepenuhnya padahal sudah aktif mengerjakan banyak soal latihan dan try out. </p>
                            <br>
                        </div>

                        <div class="col-12 text-center ">
                            <h3>Pejuang Pendidik telah menemukan cara belajar efektif melalui metode #LearnDoTeach</h3>
                        </div>
                        
                        <!-- <div class="col-12 text-center">
                            <br>
                            <LazyYoutube
                            ref="youtubeLazyVideo"
                            src="https://youtu.be/J1HIWKCvzOo"
                            max-width="400px"
                            aspect-ratio="16:9"
                            thumbnail-quality="standard"
                            />
                        </div> -->


                        <div class="col-12 text-center px-2 pt-1 pb-0.5">
                            <p>Alhamdulillah sudah terbukti  dipercaya membantu ribuan Sobat Pejuang mewujudkan mimpinya menjadi PNS, PPPK, Pegawai BUMN, Lolos Sekolah Kedinasan dan diterima di Perguruan Tinggi Negeri favorit. </p>
                            <p>Mereka telah membuktikannya, sekarang giliran Anda!!</p>
                            <br>
                            <div>
                                <router-link to="/login" class="btn banner-primary">Ayo Bergabung Sekarang</router-link>
                            </div>
                        </div>
                    </div>

                    </template>
                    <template v-else>
                        <!-- <div class="col-paket" v-if="idcat == '5'">
                            <a class="products-list__item"  href="https://ayocpns.com/belajar/register?ref=AKUCPNS" target="_blank" style="height: 375px;"> 
                                <div class="product-card product-promo-card"> 
                                    <div class="product-card__badges-list"> 
                                    </div> 
                                    <div class="product-card__image">
                                        <a> 
                                            <img src="@/assets/img/ayocpns.png" alt="">
                                        </a> 
                                    </div> 
                                    <div class="product-card__info"> 
                                        <div class="product-card__name">
                                            <a class="font-semibold" >BIMBEL SKD CPNS BATCH 12 - AYOCPNS</a><br>
                                        </div> 
                                        
                                    </div> 
                                </div> 
                            </a>
                        </div> -->

                        <!-- <div class="col-paket" v-if="idcat == '9'">
                            <a class="products-list__item"  href="https://ayopppk.com/gabung?ref=PPPK2021" target="_blank" style="height: 375px;"> 
                                <div class="product-card product-promo-card"> 
                                    <div class="product-card__badges-list"> 
                                    </div> 
                                    <div class="product-card__image">
                                        <a> 
                                            <img src="@/assets/img/ayopppk.png" alt="">
                                        </a> 
                                    </div> 
                                    <div class="product-card__info"> 
                                        <div class="product-card__name">
                                            <a class="font-semibold" >Bimbel PPPK Manajerial & SosioKultural #5 - AYO PPPK</a><br>
                                        </div>                                    
                                    </div> 
                                </div> 
                            </a>
                        </div> -->

                        <template v-if="lstpaket">
                        <div class="col-paket"  v-for="(ref) in lstpaket" :key="ref.id_paket">
                            <a class="products-list__item"  @click.prevent="getDetail(ref)" v-if="ref.fg_pendaftaran == '2'"> 
                                <div class="product-card product-promo-card"> 
                                    <input clas="post" id="id_produk" name="id_produk" type="hidden" value="270"> 
                                    <div class="product-card__badges-list" v-if="ref.fg_slot =='2'"> 
                                        <div class="product-card__badge product-card__badge--sale bg-slot"  v-if="ref.fg_pendaftaran == '2'">{{ref.slot}} Slot</div> 
                                    </div> 
                                    <div class="product-card__image">
                                        <a> 
                                            <img :src="ref.url_gambar" alt="">
                                        </a> 
                                    </div> 
                                    <div class="product-card__info"> 
                                        <div class="product-card__name">
                                            <a class="font-semibold">{{ref.nama_paket}}</a>
                                        </div> 
                                        <!-- <div class="bg-warning px-2 pt-1 pb-0.5 tersedia">
                                            <p>Tersedia {{ref.slot}} Slot</p>
                                        </div> -->
                                        <div class="flex items-center mt-1">
                                            <div class="sm:flex items-center">
                                                <h4 class="font-medium text-xs sm:text-sm text-red-600 mr-1">
                                                    <del>Rp{{ref.harga_awal}}</del>
                                                </h4> 
                                                <h3 class="font-semibold text-base text-gray-900">Rp{{ref.harga_aktif}}</h3>
                                            </div>
                                        </div>
                                    </div> 
                                </div> 
                            </a>

                            <div class="products-list__item" v-if="ref.fg_pendaftaran == '1'"> 
                                <div class="product-card product-promo-card"> 
                                    <input clas="post" id="id_produk" name="id_produk" type="hidden" value="270"> 
                                    <div class="product-card__badges-list"> 
                                        <div class="product-card__badge product-card__badge--sale bg-bearkhir" v-if="ref.fg_pendaftaran == '1'">Pendaftaran Berakhir</div> 
                                    </div> 
                                    <div class="product-card__image">
                                        <a> 
                                            <img :src="ref.url_gambar" alt="">
                                        </a> 
                                    </div> 
                                    <div class="product-card__info"> 
                                        <div class="product-card__name">
                                            <a  class="font-semibold">{{ref.nama_paket}}</a>
                                        </div> 
                                        <!-- <div class="bg-warning px-2 pt-1 pb-0.5 tersedia">
                                            <p>Tersedia {{ref.slot}} Slot</p>
                                        </div> -->
                                        <div class="flex items-center mt-1">
                                            <div class="sm:flex items-center">
                                                <h4 class="font-medium text-xs sm:text-sm text-red-600 mr-1">
                                                    <del>Rp{{ref.harga_awal}}</del>
                                                </h4> 
                                                <h3 class="font-semibold text-base text-gray-900">Rp{{ref.harga_aktif}}</h3>
                                            </div>
                                        </div>
                                    </div> 
                                </div> 
                            </div>

                        </div>
                        </template>
                        <template v-else>
                            <div class="col-12 text-center" v-if="idcat != '5' && idcat != '9'">
                                <div class="img-part">
                                    <img src="https://img.icons8.com/arcade/64/000000/experimental-error-arcade.png">
                                </div>  <br> 
                                <h5 class="text-info">Maaf, Paket tidak ditemukan</h5>
                            </div>


                        </template>
                    </template>

                </div>
            </div>

        </section>


    </section> 

    
</template>


<script>
import VueSlickCarousel from 'vue-slick-carousel'
import LazyTube from "vue-lazytube"
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import axios from 'axios';
import {mapGetters} from 'vuex'

const images = require.context('@/assets/img/banners', false, /\.png$|\.jpg$/)
// import LazyYoutubeVideo from "vue-lazy-youtube-video";

    
  export default {
    name: 'MyComponent',
    components: { VueSlickCarousel },
    data() {
      return {
        settings: {
            // arrows: true,
            dots: true,
            // "infinite": true,
            // // "slidesToShow": 3,
            // "slidesToScroll": 1,
            "autoplay": true,
            // "speed": 2000,
            // "autoplaySpeed": 4000,
            // "cssEase": "linear"
            
            autoplaySpeed: 2500,
            dots: true,
            fade: true,
            // arrows: false,
            // "centerMode": true,
            // "centerPadding": "20px",
            "focusOnSelect": true,
            "infinite": true,
            "slidesToShow": 1,
            "speed": 500
        },
        settingCategory: {            
            "infinite": true,
            "slidesToShow": 4,
            // "speed": 500,
            "rows": 1,
            // "slidesPerRow": 1,
            "slidesToScroll": 4          
        },
        lstkatbanner: [], idcat: '', namakat:'',
        lstkat: [],
        lstpaket: [],
        
        // videos: [
        //     {
        //     url: "https://www.youtube.com/embed/4JS70KB9GS0",
        //     previewImageSize: "maxresdefault"
        //     },
        //     {
        //     url: "https://www.youtube.com/embed/65MVwN_Kz1Q",
        //     previewImageSize: "hqdefault"
        //     },
        //     {
        //     url: "https://www.youtube.com/embed/KbX1gYtPVYE",
        //     previewImageSize: "sddefault",
        //     aspectRatio: "1:1"
        //     },
        //     {
        //     url: "https://www.youtube.com/embed/etKOc80-cw0",
        //     previewImageSize: "mqdefault"
        //     }
        // ]
      }
    },     
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        })
    },
    created:function(){
        this.idcat = this.$route.query.idcat
        this.getAllKategoriBanner();
        this.getAllKategori();
        this.getAll();
        // console.log(idcat);
	}, 
    methods: {
        getAllKategori: function () {
            axios.get('kategoriorderbyaktif')
                .then(res => {
                    // console.log(res);
                    this.lstkat = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        getAllKategoriBanner: function () {
            axios.get('kategoribanner/'+this.idcat)
                .then(res => {
                    // console.log(res);
                    this.namakat = res.data.namakat;
                    this.lstkatbanner = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        getKategori: function(vidcat) {
            console.log("vidcat : " +vidcat);
            this.idcat = vidcat;
            this.getAllKategoriBanner();
            this.getAllKategori();
            this.getAll();
        },
	    loadImg(imgPath) {
            return images('./' + imgPath)        
        },

        getAll: function () {
            var xurl = 'paketgeneral/'+this.idcat;
            if(this.isLoggedIn) xurl = 'paketgeneralbyuser/'+this.user.id_user+'/'+this.idcat;
            axios.get(xurl)
                .then(res => {
                    // console.log(res.data);
                    // this.clearTbl("tbl");
                    if(res.data)
                        this.lstpaket = res.data.data;
                    else
                        this.lstpaket = [];
                })
                .catch(err => {
                    // handle error
                    this.lstpaket = [];
                    console.log(err);
                })
        },
        
        getDetail: function (ref) {
            // if(localStorage.getItem('idUser'))
            if(this.isLoggedIn){
                
                localStorage.setItem("idPaket",  ref.id_paket); 
                this.$router.push({name:'siswa-paket-belajar-detail'});//, params: {id: ref.id_paket}});
            
            }
            else
                this.$router.push({name:'home-detail-paket', params: {id: ref.id_paket}});

        },

    }
  }
// import { defineComponent } from 'vue';
// // import 'vue3-carousel/dist/carousel.css';
// import { Carousel, Navigation, Slide, Pagination } from 'vue3-carousel';
// export default defineComponent({
//   name: 'ExamplePagination',
//   components: {
//     Pagination,
//     Carousel,
//     Slide,
//     Navigation,
//   },
//   data: () => ({
//     // carousel settings
//     settings: {
//       itemsToShow: 1,
//       snapAlign: 'center',
//     },
//     // breakpoints are mobile first
//     // any settings not specified will fallback to the carousel settings
//     breakpoints: {
//       // 700px and up
//       700: {
//         itemsToShow: 3.5,
//         snapAlign: 'center',
//       },
//       // 1024 and up
//       1024: {
//         itemsToShow: 5,
//         snapAlign: 'start',
//       },
//     },
//   }),
// });

// import { Carousel, Slide } from 'vue-carousel';
// export default {
//   components: {
//     Carousel,
//     Slide
//   }
// };

//   import { ref } from "vue";
// import { MDBCarousel } from "mdb-vue-ui-kit";
//   export default {
//     components: {
//       MDBCarousel
//     },
//     setup() {
//       const items8 = [
//         {
//           src: "https://mdbootstrap.com/img/Photos/Slides/img%20(19).webp",
//           alt: "...",
//           label: "First slide label",
//           caption: "Nulla vitae elit libero, a pharetra augue mollis interdum."
//         },
//         {
//           src: "https://mdbootstrap.com/img/Photos/Slides/img%20(35).webp",
//           alt: "...",
//           label: "Second slide label",
//           caption: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
//         },
//         {
//           src: "https://mdbootstrap.com/img/Photos/Slides/img%20(40).webp",
//           alt: "...",
//           label: "Third slide label",
//           caption:
//             "Praesent commodo cursus magna, vel scelerisque nisl consectetur."
//         }
//       ];
//       const carousel8 = ref(0);
//       return {
//         items8,
//         carousel8
//       };
//     }
//   };

</script>


// WEBPACK FOOTER //
// src/components/Category/Banner/index.vue